import ForgotPasswordModal from './forgot_password_modal'
export default ForgotPasswordModal
